import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuthStore } from '../stores/authStore';

export default function ProtectedRoute({ children }) {
  const admin = useAdminAuthStore((state) => state.admin);
  const accessToken = useAdminAuthStore((state) => state.accessToken);

  if (!admin || !accessToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
